import moment from "moment";


// 27th Feb 2023
const UxFriendlyDate = 'Do MMM YYYY';
const UxFriendlyDateTime = 'Do MMM YYYY h:mm a';
const UxFriendlyTime = 'h:mm a';
const ShortDate = 'DD/MM/YYYY';

export const DateUtil = {

	ToFriendlyDateString(
		date: Date | null | undefined,
		options?: {
			isUtc?: boolean
		}
	): string | null {
		if (!date) return null;
		const { isUtc = true } = options ?? {};
		const m = isUtc ? moment.utc(date) : moment(date);
		return m.local().format(UxFriendlyDate);
	},

	ToFriendlyDateTimeString: function (
		date: Date | null | undefined,
		options?: {
			isUtc?: boolean
		}
	): string | null {
		if (!date) return null;
		const { isUtc = true } = options ?? {};
		const m = isUtc ? moment.utc(date) : moment(date);
		return m.local().format(UxFriendlyDateTime);
	},

	ToShortDate: function (
		date: Date | null | undefined,
		options?: {
			isUtc?: boolean
		}): string | null {

		if (!date) return null;
		const { isUtc = true } = options ?? {};
		const m = isUtc ? moment.utc(date) : moment(date);
		return m.local().format(ShortDate);
	},

	ToTimeString: function (
		date: Date | null | undefined,
		options?: {
			isUtc?: boolean
		}): string | null {

		if (!date) return null;
		const { isUtc = true } = options ?? {};
		const m = isUtc ? moment.utc(date) : moment(date);
		return m.local().format(UxFriendlyTime);
	},

	todayISO(): string {
		return new Date().toISOString().split('T')[0];
	},

	// Compares calendar dates only; both sides are normalised to UTC first so local-timezone conversion can't shift them onto different days.
	isSameCalendarDate(a: Date, b?: Date): boolean {
		if (!b) return false;
		return moment.utc(a).format("YYYY-MM-DD") === moment.utc(b).format("YYYY-MM-DD");
	},
}
